import { z } from "zod";

export const CREDENTIAL_SCOPES = ["read_events", "read_exports", "request_checks", "read_profiles"] as const;
export const credentialScopeSchema = z.enum(CREDENTIAL_SCOPES);
export type CredentialScope = z.infer<typeof credentialScopeSchema>;

export const CREDENTIAL_SCOPE_LABELS: Record<CredentialScope, string> = {
  read_events: "Read events",
  read_exports: "Read exports",
  request_checks: "Request passage checks",
  read_profiles: "Read profiles",
};

export const MACHINE_ROUTE_SCOPES = {
  "GET /machine/v1/events": "read_events",
  "GET /machine/v1/events/:event_id": "read_events",
  "GET /machine/v1/changes": "read_events",
  "GET /machine/v1/artifacts/:artifact_id": "read_events",
  "POST /machine/v1/snapshots": "read_exports",
  "GET /machine/v1/snapshots/:snapshot_id": "read_exports",
  "POST /machine/v1/passage-checks": "request_checks",
  "GET /machine/v1/passage-checks/:check_id": "request_checks",
  "GET /machine/v1/profiles": "read_profiles",
  "GET /machine/v1/profiles/:profile_id": "read_profiles",
} as const satisfies Record<string, CredentialScope>;

export type MachineRoute = keyof typeof MACHINE_ROUTE_SCOPES;

export const credentialSecretPattern = /^amb_mc_[0-9A-HJKMNP-TV-Z]{26}_[A-Za-z0-9_-]{43}$/;

export function scopeAllows(granted: readonly CredentialScope[], route: MachineRoute): boolean {
  return granted.includes(MACHINE_ROUTE_SCOPES[route]);
}
